import { render, staticRenderFns } from "./terra.vue?vue&type=template&id=fa634f14"
import script from "./terra.vue?vue&type=script&lang=js"
export * from "./terra.vue?vue&type=script&lang=js"
import style0 from "./terra.vue?vue&type=style&index=0&id=fa634f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports